require('@rails/ujs').start()
import "@hotwired/turbo-rails";
import "../turbo_stream_actions";

require('trix')
require('@rails/actiontext')
require('fullcalendar/fullcalendar.js')

global.toastr = require('toastr')

import 'bootstrap'

import '../src/global'
import '../src/static_pages'
import '../src/groups'
import '../src/types'
import '../src/users'
import '../src/bookings'
import 'chartkick/chart.js'
// Load flatpickr's vendor CSS BEFORE our own styles so our overrides
// (app/javascript/styles/flatpickr.scss) cascade last and win.
require('flatpickr/dist/flatpickr.css')
require('flatpickr/dist/themes/airbnb.css')
import '../styles/styles'
import 'tom-select'

import '../controllers'

import flatpickr from 'flatpickr'
import { German } from 'flatpickr/dist/l10n/de.js'
